import React, { useState, useEffect } from "react";
import {  useSelector } from "react-redux";
import { Box, Button, Grid, IconButton, Tooltip, Typography, useMediaQuery } from "@mui/material";
import moment from "moment";
import {
  fcheck_null_undefine_replace_empty,
   getStatusStyleV1,
} from "../../Utility/Utilitys";
import {  Trip_IMPUR01A_Close_Summary } from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import HeaderComponent from "./ProcessComponent/HeaderComponent";
import { DataGridPro, gridRowIdsSelector, useGridApiRef, } from "@mui/x-data-grid-pro";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import TripDeactivateSideNav from "./TripIdDeactiveSidenav";


const PurchaseCloseSummary = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:950px)");
  const status = ["All", "Enter", "Post"];

  const [summaryData, setSummaryData] = useState([]);
  const [sidenavOpen, setSidenavOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxUserInfoObj = vRdxUserInfo();

  const [filterObj, setFilterObj] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date(),
    location: vRdxuserLoc.length > 0 ? vRdxuserLoc[0]?.UID : [],
    status: "All",
  });

  const handleLoadBtn = () => {
    fonLoad();
  };
  const handleRowClick = (params) => {
    setSelectedRow(params.row);
    // setOpen(true);
    setSidenavOpen(true);
  };

  const fFilter = () => {
    // setOpenFilterModal(true);
  };

  const apiRef = useGridApiRef();
  const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    // ALL loaded rows (ignores selection)
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
    // allColumns: true,
  });
};

const fonLoad = async () => {
  try {
    const obj = {
      FromDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY"),
      ToDate: moment(filterObj?.dateTo).format("MM/DD/YYYY"), // ⚠️ fixed
    };

    const FinalObj = fcheck_null_undefine_replace_empty(obj);

    const resp = await Trip_IMPUR01A_Close_Summary(FinalObj);
    console.log("Full API response:", resp);

    if (resp?.status === 200 && Array.isArray(resp?.data?.ResultSet)) {
      const resWithUniqueId = resp.data.ResultSet.map((item, index) => ({
        ...item,
        id: index + 1,
      }));

      setSummaryData(resWithUniqueId);
    } 
  } catch (error) {
   
  }
};

  useEffect(() => {
    fonLoad();
    // setSidenavOpen(true);
  }, []);

  return (
    <div className="div-container">
      <Box pt={2}>
        {vMediaQuery ? (
          <Grid container>
            <Grid item xs={8}>
              <Typography
                variant={vMediaQuery ? "subtitle2" : "h6"}
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600, mt: 0.5 }}
              >
                De-Activate
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={1}>
              <Tooltip title="Export CSV">
                <IconButton color="primary" onClick={handleExport} size="small">
                  <DownloadOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              De-Activate
            </Typography>

            <HeaderComponent
              status={status}
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              vRdxDBLocation={vRdxuserLoc}
              handleLoadBtn={handleLoadBtn}
              handleExport={handleExport}
              title=" De-Activate"
            />
          </>
        )}

        <Box
          sx={{
            mt: vMediaQuery ? 3 : 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: { xs: "75vh", sm: "60vh", md: "68vh", lg: "68vh" },
            width: "100%",
          }}
        >
          <DataGridPro
            rowHeight={30}
            headerHeight={40}
            // components={{
            //   Toolbar: GridToolbar,
            // }}
            apiRef={apiRef}
            rows={summaryData}
            // getRowId={(v) => v.id}
            columns={[
              {
                field: "TripId",
                headerName: "Trip Id",
                align:"center",
                headerAlign:"center",
                width: xMediaQuery ? 60 : 80,
              },
                {
                field: "Name",
                headerName: "Trip Name",
                width: xMediaQuery ? 120 : 360,
              },
              {
                field: "Expt_From",
                headerName: "Expected From",
                width: xMediaQuery ? 80 : 110,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "Expt_To",
                headerName: " Expected To",
                width: 110,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
             
                  },
          
              {
                field: "NoOfOrders",
                headerName: "No Of Orders",
                width: 100,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "NoOfPurchase",
                headerName: "No Of Purchase",
                width: 110,
                align: "center",
                headerAlign: "center",
                
              },
              {
                field: "BuyerName",
                headerName: "BuyerName",
               width:200,
               headerAlign:"left",
               align:"left",
              },
               {
                field: "NoOfExcelCount",
                headerName: "No Of ExcelCount",
               width:130,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "status",
                headerName: "Status",
               width:100,
               align:"center",
               headerAlign:"center",
                renderCell: (params) => {
                  const style = getStatusStyleV1(params.value);
                  return (
                    <div
                      style={{
                        ...style,
                        padding: "2px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      {params.value}
                    </div>
                  );
                },
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
            hideFooter
            onRowClick={handleRowClick}
          />
        </Box>
        <TripDeactivateSideNav
          selectedRow={selectedRow}
          isOpen={sidenavOpen}
          onClose={() => setSidenavOpen(false)}
          summaryLoad={fonLoad}
          summaryData={summaryData}
          isMobile={vMediaQuery}
          UserCd={vRdxUserInfoObj?.UserID}
        />
      </Box>
    </div>
  );
};

export default PurchaseCloseSummary;
